import MasterCrudPage from '../../components/MasterCrudPage';

export default function Funds() {
  return (
    <MasterCrudPage
      config={{
        title: 'Fund',
        apiBase: '/payroll/masters/funds',
        listKey: 'funds',
        entityKey: 'fund',
        fields: [
          { key: 'contributionPercentage', label: 'Contribution %', type: 'number' },
          { key: 'maxPerMonth', label: 'Max per Month', type: 'number' },
          { key: 'minimumAmount', label: 'Minimum Amount', type: 'number' },
          {
            key: 'ir8aFundType',
            label: 'Declaration',
            type: 'select',
            options: [
              { value: 'NONE', label: 'None' },
              { value: 'IR8A', label: 'IR8A' },
              { value: 'IR21', label: 'IR21' },
            ],
          },
          { key: 'applicableRace', label: 'Applicable Race (blank = all)', type: 'text', maxLength: 50 },
          { key: 'isActive', label: 'Active', type: 'checkbox' },
        ],
        bare: true,
      }}
    />
  );
}
